import { Box, Button, Dialog, DialogContent, DialogTitle, IconButton, ImageList, ImageListItem, Modal, Typography, useMediaQuery } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch, useSelector } from 'react-redux';
import { getProfile } from '../../../reducer/profileSlice';
import dayjs from 'dayjs';
import EditActivity from './EditActivity';
import ConfirmDialog from '../ComponentReuse/ConfirmDialog';
import ResponseDialog from '../ComponentReuse/ResponseDialog';
import { setEOCHistory } from '../../../reducer/eocHistorySlice';

function DetailActivity({ open, setOpen, dataActivity }) {

    const dispatch = useDispatch();
    const profile = useSelector(getProfile);
    const [openEdit, setOpenEdit] = useState(false);
    const [openDelete, setOpenDelete] = useState(false);
    const [status, setStatus] = useState("");
    const [modalResponse, setModalResponse] = useState(false);
    const [openImage, setOpenImage] = useState(false);
    const [imageIndex, setImageIndex] = useState(-1);
    const [loadedImages, setLoadedImages] = useState([]);

    useEffect(() => {
        if (dataActivity?.image_link) {
            setLoadedImages(dataActivity?.image_link);
        } else {
            setLoadedImages([]);
        }
    }, [dataActivity])

    const handleActivityTitle = () => {
        const title = dataActivity?.activity.join(", ");
        return title;
    };

    const getEOCDataTitle = () => {
        let data = {
            org_level_WO: "ระดับ",
            org_level: "กิจกรรมระหว่างเปิด EOC ระดับ"
        };
        if (dataActivity?.ep_timestamp !== undefined) {
            if (dataActivity?.org_level === "01") {
                data.org_level_WO += "ประเทศ " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "02") {
                data.org_level_WO += "เขต " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "03") {
                data.org_level_WO += "จังหวัด " + dataActivity?.province_name;
            } else if (dataActivity?.org_level === "04") {
                data.org_level_WO +=
                    "อำเภอ " +
                    dataActivity?.amphur_name +
                    " จังหวัด" +
                    dataActivity?.province_name;
            }
            return data.org_level_WO;
        } else {
            if (dataActivity?.org_level === "01") {
                data.org_level += "ประเทศ " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "02") {
                data.org_level += "เขต " + dataActivity?.org_name;
            } else if (dataActivity?.org_level === "03") {
                data.org_level += "จังหวัด " + profile?.province_name;
            } else if (dataActivity?.org_level === "04") {
                data.org_level +=
                    "อำเภอ " +
                    profile?.amphur_name +
                    " จังหวัด" +
                    profile?.province_name;
            }
            return data.org_level;
        }
    };

    const startEOCActivity = () => {
        let startEOCDate = "";
        if (dataActivity?.ep_timestamp !== undefined) {
            startEOCDate = dayjs(parseInt(dataActivity?.ep_timestamp))
                .locale("th")
                .format("DD MMMM YYYY");
        } else {
            startEOCDate = dayjs(parseInt(dataActivity?.create_timestamp))
                .locale("th")
                .format("DD MMMM YYYY");
        }
        return startEOCDate;
    };

    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.only('sm'));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.only('md'));
    const isLargeScreen = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    const getCols = () => {
        if (isSmallScreen) return 2; // สำหรับหน้าจอ sm
        if (isMediumScreen) return 4; // สำหรับหน้าจอ md
        if (isLargeScreen) return 5; // สำหรับหน้าจอ lg ขึ้นไป
        return 1; // สำหรับหน้าจอขนาดเล็กกว่า sm
    };

    const handleEditActivity = () => {
        setOpenEdit(true);
    };

    const timeUsed = () => {
        let timeUsed = false

        const createTime = dayjs(dataActivity?.create_timestamp).startOf('day');
        const nowDate = dayjs().startOf('day');
        let timeLimit = nowDate.diff(createTime, 'day')

        if (timeLimit <= process.env.REACT_APP_EDIT_LENGTH) {
            return true
        }

        return timeUsed
    }

    const handleOpenDeleteActivity = () => {
        setOpenDelete(true);
    };

    const handleDeleteWOEOC = async () => {
        try {
            let dataSend = {
                wo_eoc_id: dataActivity?.wo_eoc_id,
                creator_id: dataActivity?.creator_id,
                creator_name: dataActivity?.creator_name,
                org_id: profile?.org_id,
                org_name: profile?.org_name,
                phone: profile?.telephone,
                email: profile?.mail,
                remark: dataActivity?.remark
            };
            const response = await fetch(`${process.env.REACT_APP_API_URL}/my_eoc/delete_activity_wo_eoc`, {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(dataSend),
            });
            if (response.ok) {
                setStatus("ทำการปิด without EOC เสร็จสิ้น");
                setModalResponse(true);
            } else {
                setStatus("ไม่สามารถปิด without EOC ได้");
                setModalResponse(true);
            }
        } catch (error) {
            console.log(error);
        }
        setOpenDelete(false)
    }

    const callMyEOCData = async () => {
        try {
            let param = "";
            if (profile?.org_level === "02") {
                param = `org_id=${profile?.org_id}`;
            } else {
                param = `area_code=${profile?.area_code}`;
            }
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/my_eoc/get_eoc/${profile?.org_level}?${param}`
            );
            const data = await response.json();
            if (data.history_eoc.length !== 0) {
                dispatch(setEOCHistory(data?.history_eoc.reverse()));
            } else {
                dispatch(setEOCHistory(undefined));
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleCloseResponse = () => {
        setModalResponse(false);
        callMyEOCData();
        setOpen(false);
    };

    const onClickZoomImage = (index) => {
        setImageIndex(index);
        setOpenImage(true);
    };

    const handleClose = () => {
        setImageIndex(-1);
        setOpenImage(false);
    };

    const handleImageError = (src) => {
        setLoadedImages((prevImages) =>
            prevImages.filter((imageSrc) => imageSrc !== src)
        );
    };

    const ModalImage = () => {
        return (
            <Dialog
                open={openImage}
                // onClose={handleClose}
                fullWidth={true}
                maxWidth={'md'}
            >
                <DialogContent className='p-0 overflow-hidden'>
                    <Box
                        component={'img'}
                        src={`${process.env.REACT_APP_API_URL}/${dataActivity?.image_link[imageIndex]}`}
                        className='w-full h-full'
                    />
                    <IconButton
                        aria-label="delete"
                        size="small"
                        onClick={handleClose}
                        sx={() => ({
                            position: "absolute",
                            color: "white",
                            right: "10px",
                            top: "10px",
                            "&:hover": {
                                backgroundColor: "rgba(0, 0, 0, 0.3)",
                                boxShadow: "none",
                            },
                        })}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogContent>
            </Dialog>
        );
    }

    return (
        <Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={dataActivity?.image_link.length !== 0 ? 'lg' : 'md'}
                open={open}
                className={(openDelete || openEdit) ? 'hidden' : 'block'}
            >
                <DialogTitle className='py-3'>
                    <div>
                        <div className='flex justify-between items-center'>
                            <Typography variant="body1">
                                รายละเอียดกิจกรรม
                                <br />
                                <Typography variant="body2">{handleActivityTitle()}</Typography>
                            </Typography>
                            <IconButton
                                edge="start"
                                color="rgb(0, 0, 0)"
                                onClick={() => setOpen(false)}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent className='grid gap-6 md:px-16' dividers>
                    <div className='flex justify-between'>
                        <div>
                            <Typography variant='subtitle2' className='text-[#cd6c4a]'>
                                {getEOCDataTitle()}
                            </Typography>
                            <Typography variant='body1'>
                                {startEOCActivity()}
                            </Typography>
                        </div>
                        {(dataActivity?.ep_timestamp !== undefined && timeUsed() && dataActivity?.org_id === profile?.org_id) &&
                            <div className='space-x-2'>
                                <Button
                                    variant="outlined"
                                    size='small'
                                    style={{
                                        color: "#000",
                                        borderColor: "#ccc",
                                    }}
                                    onClick={handleEditActivity}
                                >แก้ไข</Button>
                                <Button
                                    variant="outlined"
                                    size='small'
                                    style={{
                                        color: "#000",
                                        borderColor: "#ccc",
                                    }}
                                    onClick={handleOpenDeleteActivity}
                                >ลบ</Button>
                            </div>
                        }
                    </div>
                    <div>
                        <Typography className='text-[#cd6c4a]' variant='subtitle2'>
                            รายละเอียด
                        </Typography>
                        <Typography variant='body1'>
                            {dataActivity?.description === "" ? "-" : dataActivity?.description}
                        </Typography>
                    </div>
                    <div className='mb-8'>
                        <Typography className='text-[#cd6c4a] mb-2' variant='subtitle2'>
                            ภาพกิจกรรม
                        </Typography>
                        {loadedImages.length > 0 ? (
                            <div
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: "30px",
                                }}
                            >
                                <Box>
                                    <ImageList
                                        variant="masonry"
                                        cols={getCols()}
                                        gap={8}
                                    >
                                        {loadedImages.map((item, index) => {
                                            return (
                                                < ImageListItem key={index} >
                                                    <img
                                                        src={`${process.env.REACT_APP_API_URL}/${item}`}
                                                        alt={item}
                                                        loading="lazy"
                                                        style={{
                                                            cursor: 'pointer',
                                                        }}
                                                        onClick={() => {
                                                            onClickZoomImage(index)
                                                        }}
                                                        onError={() => handleImageError(item)}
                                                    />
                                                </ImageListItem>
                                            )
                                        })}
                                    </ImageList>
                                </Box>
                            </div>
                        ) : (
                            <Typography variant='body1'>
                                ไม่มีรูปกิจกรรม
                            </Typography>
                        )}
                    </div>
                </DialogContent>
            </Dialog>
            <EditActivity
                open={openEdit}
                setOpen={setOpenEdit}
                dataActivity={dataActivity}
                setCloseEdit={setOpen}
            />
            <ConfirmDialog
                open={openDelete}
                title={"ยืนยันการปิด รายงานการดำเนินกิจกรรมตอบโต้ภาวะฉุกเฉิน โดยไม่เปิด EOC"}
                onConfirm={handleDeleteWOEOC}
                onCancel={() => setOpenDelete(false)}
            />
            <ResponseDialog
                open={modalResponse}
                onClose={handleCloseResponse}
                dataResponse={status}
            />
            <ModalImage />
        </Fragment >
    )
}

export default DetailActivity